import { useTranslation } from '@/contexts/i18n-context';
import { UserEntryLayout } from '@/components/auth/user-entry-layout';
import { UserEntrySuccessCard } from '@/components/auth/user-entry-success-card';
import styles from './reset-password-page.module.css';
import { SuccessCircleSvg } from '@/components/svgs/success-circle';

export function ResetPasswordSuccessPage() {
  const { t } = useTranslation();

  return (
    <UserEntryLayout>
      <UserEntrySuccessCard
        title={t('passwordReset.reset.success.title')}
        subtitle={t('passwordReset.reset.success.description')}
        icon={<SuccessCircleSvg className={styles.icon} />}
        hasLoginButton
      />
    </UserEntryLayout>
  );
}
